<template>
	<v-container grid-list-md>
		<v-card flat>
			<v-card-text>
				<v-layout row wrap>
					<v-flex xs12>
						<v-card>
							<v-card-title style="background-color: #eceff1">
								{{ $t("label.delivery_setting") }}
							</v-card-title>
							<v-divider></v-divider>
							<v-card-text>
								<v-layout row wrap>
									<v-flex xs12 md6>
										<strong>
											{{ $t("Enable Delivery Module") }}
										</strong>
										<br />
										<small>
											{{
												$t(
													"Choose the enable or disable delivery module on web or mobile."
												)
											}}
										</small>
									</v-flex>
									<v-flex xs12 md6 class="d-flex flex-row">
										<v-checkbox
											v-model="
												item.delivery_availability_web_app
											"
											:label="$t('Web App')"
											class="mr-10"
										></v-checkbox>

										<v-checkbox
											v-model="
												item.delivery_availability_mobile_app
											"
											:label="$t('Mobile App')"
										></v-checkbox>
									</v-flex>
									<v-divider></v-divider>
									<v-flex xs12 md6>
										<strong>
											{{ $t("Shipping Fee") }}
										</strong>
										<br />
										<small>
											{{
												$t(
													"Determine the amount of shipping fee per order"
												)
											}}
										</small>
									</v-flex>
									<v-flex xs12 md6>
										<v-text-field
											v-model="item.shipping_fee"
											suffix="USD"
										></v-text-field>
									</v-flex>
									<v-divider></v-divider>
									<v-flex xs12 md6>
										<strong>
											{{ $t("Delivery Distance") }}
										</strong>
										<br />
										<small>
											{{
												$t(
													"Set the distance of delivery area from the restaurant in kilometers (km)"
												)
											}}
										</small>
									</v-flex>
									<v-flex xs12 md6>
										<v-text-field
											v-model="item.delivery_distance"
											suffix="km"
										></v-text-field>
									</v-flex>
									<v-divider></v-divider>
									<v-flex xs12 md6>
										<strong>
											{{
												$t("Payment on delivery limit")
											}}
										</strong>
										<br />
										<small>
											{{
												$t(
													"Set the amount of limit for payment on delivery"
												)
											}}
										</small>
									</v-flex>
									<v-flex xs12 md6>
										<v-text-field
											v-model="
												item.payment_on_delivery_limit
											"
											suffix="USD"
											type="number"
											:hint="
												$t(
													'Input 0 if don\'t want to limit'
												)
											"
											persistent-hint
										></v-text-field>
									</v-flex>
									<v-divider></v-divider>
									<v-flex xs12 md6>
										<strong>
											{{ $t("Operating Hours") }}
										</strong>
										<br />
										<small>
											{{
												$t(
													"Set the operating hours of the restaurant"
												)
											}}
										</small>
									</v-flex>
									<v-flex xs12 md6>
										<v-list>
											<v-list-item>
												<v-list-item-action>
													<v-checkbox
														v-model="
															item.delivery_monday
														"
													>
													</v-checkbox>
												</v-list-item-action>
												<v-list-item-content>
													<v-list-item-title>
														{{ $t("Monday") }}
													</v-list-item-title>
												</v-list-item-content>
											</v-list-item>
											<v-list-item>
												<v-list-item-action>
													<v-checkbox
														v-model="
															item.delivery_tuesday
														"
													>
													</v-checkbox>
												</v-list-item-action>
												<v-list-item-content>
													<v-list-item-title>
														{{ $t("Tuesday") }}
													</v-list-item-title>
												</v-list-item-content>
											</v-list-item>
											<v-list-item>
												<v-list-item-action>
													<v-checkbox
														v-model="
															item.delivery_wednesday
														"
													>
													</v-checkbox>
												</v-list-item-action>
												<v-list-item-content>
													<v-list-item-title>
														{{ $t("Wednesday") }}
													</v-list-item-title>
												</v-list-item-content>
											</v-list-item>
											<v-list-item>
												<v-list-item-action>
													<v-checkbox
														v-model="
															item.delivery_thursday
														"
													>
													</v-checkbox>
												</v-list-item-action>
												<v-list-item-content>
													<v-list-item-title>
														{{ $t("Thursday") }}
													</v-list-item-title>
												</v-list-item-content>
											</v-list-item>
											<v-list-item>
												<v-list-item-action>
													<v-checkbox
														v-model="
															item.delivery_friday
														"
													>
													</v-checkbox>
												</v-list-item-action>
												<v-list-item-content>
													<v-list-item-title>
														{{ $t("Friday") }}
													</v-list-item-title>
												</v-list-item-content>
											</v-list-item>
											<v-list-item>
												<v-list-item-action>
													<v-checkbox
														v-model="
															item.delivery_saturday
														"
													>
													</v-checkbox>
												</v-list-item-action>
												<v-list-item-content>
													<v-list-item-title>
														{{ $t("Saturday") }}
													</v-list-item-title>
												</v-list-item-content>
											</v-list-item>
											<v-list-item>
												<v-list-item-action>
													<v-checkbox
														v-model="
															item.delivery_sunday
														"
													>
													</v-checkbox>
												</v-list-item-action>
												<v-list-item-content>
													<v-list-item-title>
														{{ $t("Sunday") }}
													</v-list-item-title>
												</v-list-item-content>
											</v-list-item>
										</v-list>
									</v-flex>
								</v-layout>
							</v-card-text>
						</v-card>
					</v-flex>
					<p>&nbsp;</p>
					<v-flex xs12>
						<v-card>
							<v-card-title style="background-color: #eceff1">
								{{ $t("Pickup Setting") }}
							</v-card-title>
							<v-divider></v-divider>
							<v-card-text>
								<v-layout row wrap>
									<v-flex xs12 md6>
										<strong>
											{{ $t("Enable Pickup Module") }}
										</strong>
										<br />
										<small>
											{{
												$t(
													"Choose the enable or disable pickup module on web or mobile."
												)
											}}
										</small>
									</v-flex>
									<v-flex xs12 md6 class="d-flex flex-row">
										<v-checkbox
											v-model="
												item.pickup_availability_web_app
											"
											:label="$t('Web App')"
											class="mr-10"
										></v-checkbox>

										<v-checkbox
											v-model="
												item.pickup_availability_mobile_app
											"
											:label="$t('Mobile App')"
										></v-checkbox>
									</v-flex>
									<v-divider></v-divider>
									<v-flex xs12 md6>
										<strong>
											{{ $t("Minute to pickup") }}
										</strong>
										<br />
										<small>
											{{
												$t(
													"Set the maximum time to pickup the order."
												)
											}}
										</small>
									</v-flex>
									<v-flex xs12 md6>
										<v-text-field
											:label="
												$t(
													'label.pickup_minute_to_order'
												)
											"
										></v-text-field>
									</v-flex>

									<v-divider></v-divider>
									<v-flex xs12 md6>
										<strong>
											{{ $t("Payment on pickup limit") }}
										</strong>
										<br />
										<small>
											{{
												$t(
													"Set the amount of limit for payment on pickup"
												)
											}}
										</small>
									</v-flex>
									<v-flex xs12 md6>
										<v-text-field
											v-model="
												item.payment_on_pickup_limit
											"
											suffix="USD"
											type="number"
											:hint="
												$t(
													'Input 0 if don\'t want to limit'
												)
											"
											persistent-hint
										></v-text-field>
									</v-flex>
								</v-layout>
							</v-card-text>
						</v-card>
					</v-flex>
					<p>&nbsp;</p>
					<v-flex xs12>
						<v-card>
							<v-card-title style="background-color: #eceff1">
								{{ $t("Dine-In Setting") }}
							</v-card-title>
							<v-divider></v-divider>
							<v-card-text>
								<v-layout row wrap>
									<v-flex xs12 md6>
										<strong>
											{{ $t("Enable Dine-In Module") }}
										</strong>
										<br />
										<small>
											{{
												$t(
													"Choose the enable or disable dine-in module on web or mobile."
												)
											}}
										</small>
									</v-flex>
									<v-flex xs12 md6 class="d-flex flex-row">
										<v-checkbox
											v-model="
												item.dine_in_availability_web_app
											"
											:label="$t('Web App')"
											class="mr-10"
										></v-checkbox>

										<v-checkbox
											v-model="
												item.dine_in_availability_mobile_app
											"
											:label="$t('Mobile App')"
										></v-checkbox>
									</v-flex>
									<v-divider></v-divider>

									<v-flex xs12 md6>
										<strong>
											{{ $t("Payment on dine-in limit") }}
										</strong>
										<br />
										<small>
											{{
												$t(
													"Set the amount of limit for payment on dine-in"
												)
											}}
										</small>
									</v-flex>
									<v-flex xs12 md6>
										<v-text-field
											v-model="
												item.payment_on_dine_in_limit
											"
											suffix="USD"
											type="number"
											:hint="
												$t(
													'Input 0 if don\'t want to limit'
												)
											"
											persistent-hint
										></v-text-field>
									</v-flex>
								</v-layout>
							</v-card-text>
						</v-card>
					</v-flex>
					<p>&nbsp;</p>
					<v-flex xs12>
						<v-card>
							<v-card-title style="background-color: #eceff1">
								{{ $t("General Setting") }}
							</v-card-title>
							<v-divider></v-divider>
							<v-card-text>
								<v-layout row wrap>
									<v-flex xs12 md6>
										<strong>
											{{ $t("Prefix") }}
										</strong>
										<br />
										<small>
											{{
												$t(
													"Set the order code prefix, which will be displayed on statement."
												)
											}}
										</small>
									</v-flex>
									<v-flex xs12 md6>
										<v-text-field
											v-model="item.prefix"
											prepend-inner-icon="mdi-tag-text-outline"
										></v-text-field>
									</v-flex>
									<v-divider></v-divider>

									<v-flex xs12 md6>
										<strong>
											{{ $t("Maximum COD amount") }}
										</strong>
										<br />
										<small>
											{{
												$t(
													"Set the maximum amount of COD that can be paid by customer."
												)
											}}
										</small>
									</v-flex>
									<v-flex xs12 md6>
										<v-text-field
											v-model="item.cod_max_amount"
											:label="$t('Maximum COD amount')"
											prepend-inner-icon="mdi-currency-usd"
										></v-text-field>
									</v-flex>
								</v-layout>
							</v-card-text>
						</v-card>
					</v-flex>
				</v-layout>
			</v-card-text>
			<v-divider></v-divider>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn
					@click="submit()"
					color="primary"
					:loading="item.processing"
				>
					<v-icon left>mdi-content-save</v-icon>
					{{ $t("Save") }}</v-btn
				>
				<v-spacer></v-spacer>
			</v-card-actions>
		</v-card>
	</v-container>
</template>

<script>
import CentralLayout from "../../../layouts/central.vue";
import CentralSettingLayout from "../../../layouts/partials/central/setting.vue";
export default {
	layout: [CentralLayout, CentralSettingLayout],

	props: ["data"],

	data() {
		return {
			item: this.$inertia.form(this.data),
		};
	},

	methods: {
		async submit() {
			try {
				this.item.post(
					this.$route("central.settings.store", {
						key: "order",
					})
				);
			} catch (error) {
				this.$toast.error(error.message);
			}
		},
	},
};
</script>